import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { apiGetAvailableFlavors } from "Root/api/apiProfile";
import { setGinUserCart, setSettingsStoreAction, } from "Root/profile/redux/actionCreators/makeActionCreator";
import { BuyNowThunkV2, RecalculateOrderThunk, } from "Root/profile/redux/thunkCreators/getItNow/getItNowThunk";
import useYourSubscriptionV2 from "../YourSubscriptionV2/useYourSubscriptionV2";
import { formatPrice } from "../../BYBFlow/PDP/Customizer";
const useGetItNow = () => {
    const { hash } = useLocation();
    const history = useHistory();
    const reduxUserCart = useSelector((state) => state.userCart);
    const getItNowProducts = useSelector((state) => state.getItNow.userCart);
    const remainingItems = reduxUserCart.filter((item) => {
        const getItNowItems = getItNowProducts.map((gProduct) => gProduct.item_type);
        return !getItNowItems.includes(item.item_type);
    });
    const dispatch = useDispatch();
    const { applyPromo } = useYourSubscriptionV2();
    const applySmsPromo = async () => {
        const search = hash.split("?");
        const selectedFlavors = new URLSearchParams(search.length > 1 ? search[1] : "");
        const promo = selectedFlavors.get("code");
        if (promo) {
            await applyPromo(promo);
            await dispatch(RecalculateOrderThunk([...getItNowProducts]));
        }
    };
    const getFlavorBoosts = async () => {
        const data = await apiGetAvailableFlavors("protein");
        const search = hash.split("?");
        const selectedFlavors = new URLSearchParams(hash.length > 2 ? search[1] : "");
        const flavorBoosts = data.flavors
            .map((item) => ({
            ...item,
            quantity: Number(selectedFlavors.get(item.short_name)),
            sku: `additional_${item.short_name}`,
            item_type: "flavorboost",
            bags_info: [
                {
                    attributes: [],
                    sku: `additional_${item.short_name}`,
                    quantity: Number(selectedFlavors.get(item.short_name)),
                    selected_flavors: [],
                    id: "",
                    applyAll: false,
                },
            ],
            available_flavors: [],
            title: item.full_name,
            attributes: [],
            flavors: [],
            currentReduxQuantity: Number(selectedFlavors.get(item.short_name)),
            servings: "7",
            net_price: `$${Number(Number(selectedFlavors.get(item.short_name)) * 3).toFixed(2)}`,
            gross_price: `$${Number(Number(selectedFlavors.get(item.short_name)) * 3).toFixed(2)}`,
            item_key: "flavorboost",
            item_category: "",
            description: "",
            max_flavors: 1,
            product_explanation: "",
            delivery_cadence: "",
            skus_list: [],
            flavor_attribute_description: "",
            quantity_description: "",
            checkout_image_url: item.image_url,
        }))
            .filter((item) => item.quantity);
        dispatch(setGinUserCart([...flavorBoosts]));
        dispatch(RecalculateOrderThunk([...flavorBoosts]));
    };
    useEffect(() => {
        const product = hash.replace("#", "");
        if (product.indexOf("flavorboost") > -1) {
            getFlavorBoosts();
            return;
        }
        const getItNowItem = reduxUserCart.find((item) => item.item_type === product);
        if (getItNowItem) {
            dispatch(setGinUserCart([getItNowItem]));
            dispatch(RecalculateOrderThunk([getItNowItem]));
        }
    }, [hash, reduxUserCart]);
    useEffect(() => {
        applySmsPromo();
    }, []);
    const addGetItNowProduct = (itemType) => {
        const getItNowItem = reduxUserCart.find((item) => item.item_type === itemType);
        if (getItNowItem) {
            dispatch(setGinUserCart([...getItNowProducts, getItNowItem]));
            dispatch(RecalculateOrderThunk([...getItNowProducts, getItNowItem]));
        }
    };
    const addGetItNowProductBySku = (product) => {
        const mapGinToCart = {
            ...product,
            sku: product.product_id,
            quantity: 1,
            gross_price: formatPrice(product.prices.gross_unit_prices[1]),
            otb_gross_price: formatPrice(product.prices.otb_unit_prices[1]),
            net_price: formatPrice(product.prices.discounted_unit_prices[1] ||
                product.prices.gross_unit_prices[1]),
            otb_net_price: formatPrice(product.prices.otb_unit_prices[1]),
            currentReduxQuantity: 1,
            available_flavors: [[], []],
            bags_info: [{ sku: product.product_id, quantity: 1 }],
        };
        dispatch(setGinUserCart([...getItNowProducts, mapGinToCart]));
        dispatch(RecalculateOrderThunk([...getItNowProducts, mapGinToCart]));
        // this will always fail for products not already in the cart,
        // for obvious reasons if you read the following line
        // const getItNowItem = reduxUserCart.find(
        //   (item) => item.sku === product.product_id
        // );
        // i don't know what the best path forward is. we could:
        // 1. add the product to the cart, then add the item to the GIN order
        // 2. hardcode what the greens would look like as part of the GIN order
        // and just see if the sku is one of the two greens skus
        // 3. transform the product object into the _shape_ of a cart item
        // and then add it to the GIN order.
        // I think (3) is best. The only danger is if pricing gets messed up somehow.
        // if (getItNowItem) {
        // dispatch(setGinUserCart([...getItNowProducts, getItNowItem]));
        // }
    };
    const removeGetItNowProduct = (sku) => {
        const getItNowArr = getItNowProducts.filter((item) => item.sku !== sku);
        dispatch(setGinUserCart(getItNowArr));
        dispatch(RecalculateOrderThunk(getItNowArr));
    };
    const buyNow = () => {
        dispatch(BuyNowThunkV2(history));
        dispatch(setSettingsStoreAction(true));
    };
    return {
        getItNowProducts,
        reduxUserCart,
        addGetItNowProduct,
        addGetItNowProductBySku,
        removeGetItNowProduct,
        remainingItems,
        buyNow,
    };
};
export default useGetItNow;
